import React, { useState, useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { ExclamationCircleFilled, LaptopOutlined } from "@ant-design/icons";
import { Breadcrumb, Layout, Menu, Modal, Drawer } from "antd";
import "./css/Layout.scss";
import { useSelector } from "react-redux";
import breadcrumbNameMap from "../../utils/breadcrumb";
import { deviceHome, routes, HeadMenu } from "../../utils/menuList";

const { Header, Content, Sider, Footer } = Layout;
const { confirm } = Modal;

const MainLayout = () => {
  const navigete = useNavigate();
  const [open, setOpen] = useState(false);

  const [SiderMenu, setSiderMenu] = useState([]);

  const role = localStorage.getItem("role");

  // 面包屑
  const { pathname } = useLocation();
  const pathSnippets = pathname?.split("/")?.filter((i) => i);
  const extraBreadcrumbItems = pathSnippets?.map((_, index) => {
    let url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
    return {
      title: breadcrumbNameMap[url],
      key: index,
      // href: url,
    };
  });

  // 设置默认展示页面
  const [current, setCurrent] = useState("deviceHome");

  // const loginInfo = useSelector((state) => state.loginInfo?.info);

  // console.log(loginInfo);

  // 判断是否已登录
  useEffect(() => {
    setCurrent(pathSnippets[pathSnippets.length - 1] || "deviceHome");
    if (!localStorage.getItem("token")) {
      navigete("/login");
    }
    const role = localStorage.getItem("role");
    if (role === "root") {
      setSiderMenu([...deviceHome, ...routes]);
    } else {
      setSiderMenu([...deviceHome]);
    }
  }, [role]);

  const MenuList = [
    {
      key: "device",
      icon: <LaptopOutlined />,
      label: `设备管理`,
      children: [...SiderMenu],
    },
  ];

  // 点击顶部菜单
  const onClickMenu = ({ key }) => {
    setCurrent(key);
    clickMenu(key);
  };

  // 头部菜单
  const onClickHeadMenu = ({ key }) => {
    console.log(key);
    switch (key) {
      case "myInfo":
        setOpen(true);
        break;
      case "exit": // 退出
        confirm({
          title: "温馨提示",
          okText: "确定",
          cancelText: "取消",
          icon: <ExclamationCircleFilled />,
          content: "确认要退出系统吗？",
          onOk() {
            localStorage.clear();
            sessionStorage.clear();
            navigete("/login");
          },
          onCancel() {
            console.log("Cancel");
          },
        });

        break;
      default:
        break;
    }
  };

  // 菜单点击
  const clickMenu = (key) => {
    switch (key) {
      case "deviceHome":
        navigete("/device/deviceHome");
        break;
      case "authorization":
        navigete("/system/authorization");
        break;
      case "role":
        navigete("/system/role");
        break;
      case "commandIssued":
        navigete("/device/commandIssued");
        break;
      case "paixiang":
        navigete("/device/paixiang");
        break;
      case "history":
        navigete("/device/history");
        break;
      case "pressureMeasurement":
        navigete("/device/pressureMeasurement");
        break;
      case "exit": // 退出
        confirm({
          title: "温馨提示",
          okText: "确定",
          cancelText: "取消",
          icon: <ExclamationCircleFilled />,
          content: "确认要退出系统吗？",
          onOk() {
            localStorage.clear();
            sessionStorage.clear();
            navigete("/login");
          },
          onCancel() {
            console.log("Cancel");
          },
        });

        break;
      default:
        break;
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* 主架构 */}
      <Layout className="layout">
        <Header className="header">
          <div className="header-logo" />
          <Menu className="header-menu" selectedKeys={[current]} mode="horizontal" items={HeadMenu} theme="dark" onClick={onClickHeadMenu} />
        </Header>
        <Layout>
          <Sider width={200}>
            <Menu
              mode="inline"
              theme="dark"
              openKeys={["device", "deviceHome"]}
              selectedKeys={[current]}
              onClick={onClickMenu}
              style={{
                height: "100%",
                borderRight: 0,
              }}
              items={MenuList}
            />
          </Sider>
          <Layout
            style={{
              padding: "0 24px 0 24px",
            }}
          >
            <Breadcrumb
              style={{
                margin: "16px 0",
              }}
              items={extraBreadcrumbItems}
            ></Breadcrumb>
            <Content className="layout-content">
              <Outlet></Outlet>
            </Content>
            <Footer className="layout-footer">©2023 Created by Huawei Network</Footer>
          </Layout>
        </Layout>
      </Layout>
      <Drawer title="个人信息" placement="right" onClose={onClose} open={open}>
        个人信息
      </Drawer>
    </>
  );
};
export default MainLayout;
